// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { updateFilterText } from 'store/reducers/uiSettingsSlice';
import React, { useCallback } from 'react';
import { SearchField } from '@tls/treact-ui';

export default function Search() {
  const filterText = useAppSelector(s => s.uiSettings.filterText);
  const show = useAppSelector(s => s.uiSettings.showFilterText);
  const dispatch = useAppDispatch();
  const setFilterText = useCallback((e: string) => dispatch(updateFilterText(e)), [dispatch]);

  if (!show) return <React.Fragment />;

  return (
    <SearchField
      asAtom
      placeholder='Filter'
      value={filterText}
      onValueChange={setFilterText}
      data-testid='projects-search-input'
    />
  );
}
